<template>
    <!-- Delete Token Modal -->
    <BModal 
      id="modal-delete-token"
      ref="modal-delete-token"
      modal-class="modal-delete-token"
      hide-footer
      hide-header
      centered
      @hide="$emit('on:close')"
    >
      <IconSalesflowTriangleExclamationRounded />
      <p>{{ __('Deseja excluir este token privado?') }}</p>
      <span>{{ __('Todas as integrações realizadas por este token serão perdidas') }}</span>
      <div class="button-group">
        <button
          class="button cancel"
          type="button"
          @click="$emit('on:close')"
        >
          {{ __('Cancelar') }}
        </button>
        <button
          class="button save"
          type="button"
          @click="$emit('on:delete')"
        >
          <span v-if="deleting">{{ __('Excluindo') }}...</span><span v-else>{{ __('Excluir') }}</span>
        </button>
      </div>
    </BModal>
</template>

<script>
import { BModal } from 'bootstrap-vue';

export default {
    components: {
        BModal,
    },

    props: {
        show: {
            type: Boolean,
            default: false,
        },
        deleting: {
            type: Boolean,
            default: false,
        },
    },

    watch: {
        show(newVal) {
            if (newVal) {
                this.$refs['modal-delete-token'].show()
            } else {
                this.$refs['modal-delete-token'].hide()
            }
        },
    },

    emits: ['on:delete', 'on:close'],
};
</script>

<style scoped>
::v-deep .modal-content {
  border: none;
  width: 415px;
}

::v-deep .modal-header {
  border-radius: 16px 16px 0 0;
}

::v-deep .modal-body {
  display: flex;
  flex-direction: column;
  gap: 16px;
  border-radius: 0 0 16px 16px;
  background: #F5F5F5;
  box-shadow: 0px 8px 24px 0px rgba(0, 0, 0, 0.10);
  padding: 24px;
}

::v-deep .modal-footer {
  background: none;
  padding: 0;
}

.form-control {  
  border-radius: 8px;
  border: 1px solid  #D1D1D1;
  background: #FFF;
  padding: 13px 12px;
}

.button {
  border-radius: 14px;
  font-family: Montserrat;
  font-size: 16px;
  font-weight: 600;
  line-height: 150%;
}

.button.cancel {
  border: 1px solid #886AF8;
  color: #886AF8;
  padding: 12px 18px;
}

.cancel:hover {
  color: #FFF;
  border-color: #5F33FF;
  background-color: #5F33FF;
}

.button.save {
  border: 1px solid #2CEBA9;
  background: #2CEBA9;
  color: #242424;
  padding: 12px 32px;
}

.save:hover {
  color: #FFF;
  border-color: #1DC38A;
  background: #1DC38A;
}

.input-token {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 52px;
  gap: 8px;
  border-radius: 8px;
  padding: 16px 12px;
  border: 1px solid #D1D1D1;
  background: rgba(226, 232, 240, 0.40);
  color: #242424;
  box-sizing: border-box;
  
  span {
    flex-grow: 1;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    font-family: Montserrat;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
  }

  img {
    flex-shrink: 0;
    cursor: pointer;
  }
}

.button.conclude {
  padding: 12px 32px;
  border-radius: 14px;
  border: 1px solid #2CEBA9;
  background: #2CEBA9;
  margin-top: 8px;
}

.conclude:hover {
  color: #FFF;
  border-color: #1DC38A;
  background: #1DC38A;
}

::v-deep .modal-delete-token .modal-body {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 448px;
  padding: 56px 48px;
  gap: 24px;
  border-radius: 16px;
  background: #F5F5F5;
  box-shadow: 0px 8px 24px 0px rgba(0, 0, 0, 0.10);

  p {
    margin-bottom: 0;
    color: #242424;
    text-align: center;
    font-family: Montserrat;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 150%;
  }
}

::v-deep .modal-delete-token .modal-body > span {
  color: #71767D;
  text-align: center;
  font-family: Montserrat;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}

.button-group {
  display: flex;
  align-items: center;
  gap: 16px;
}
</style>
